import React, { FC } from 'react';
import { useTranslation } from 'hooks/use-translation';
import { NumberField } from './input-number';
import { ProjectDefaultFieldProps } from './type';

export const ArrField: FC<ProjectDefaultFieldProps> = ({
  isReadOnly,
  projectData,
  onDefaultFieldChange,
}) => {
  const arrPlaceholder = useTranslation(
    'project.overview.business_goals.arr.placeholder',
  );

  return (
    <NumberField
      placeholder={arrPlaceholder}
      value={projectData.annualizedRecurringRevenue}
      disabled={isReadOnly}
      onChange={(value) =>
        onDefaultFieldChange({
          annualizedRecurringRevenue: Number(value),
        })
      }
    />
  );
};
